import * as types from './types'
export default {
  [types.CANCEL_NEWMESSAGE](state) {
    state.messages = state.messages.filter((item) => item.id !== 0)
  },
  [types.SET_MESSAGEACTIVATION](state, data) {
    for (const item of state.messages) {
      if (item.id === data.id) {
        item.isActive = data.isActive
        item.isChanged = true
        break
      }
    }
  },
  [types.ADD_MESSAGE](state, message) {
    var cnt = 0
    for (const item of state.messages) {
      if (item.id === 0) {
        cnt++
      }
    }
    if (cnt === 0) {
      state.messages.unshift(message)
    }
  },
  [types.SET_MESSAGES](state, data) {
    state.messages = []
    if (
      data !== undefined &&
      data !== null
    ) {
      for (const item of data) {
        state.messages.push({
          id: item.id,
          message: item.text,
          isActive: item.isActive,
          sortOrder: item.sortOrder,
          isChanged: false
        })
      }
    }
  },
  [types.SET_MESSAGE](state, data) {
    for (const item of state.messages) {
      if (item.id === data.id) {
        item.message = data.message
        item.isChanged = true
        break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/message/mutations.js